module.exports = __webpack_public_path__ + "img/auxiliary-img-2.455948f9.gif";